<template>
    <div id="g-map" class="sl-map">
        <div id="map_cover" />
        <div id="map_canvas_preview" class="map_canvas_preview" />
        <div id="map_canvas" class="map_canvas" />
    </div>
</template>

<script>
import GM from '../utils/googleMaps';

export default {
    props: ['stores', 'updateAsMoving'],

    data () {
        return {
            initialLocation: null,
            last           : {
                lat: null,
                lng: null
            },
            mapInit: false,
            timer  : null
        };
    },

    methods: {
        loadMap () {
            if (this.state.map) return;

            let zoominit = 5;

            if (this.state.defaultlocation && this.state.defaultlocation === 'Korea') {
                zoominit = 7;
            }

            const myOptions = {
                zoom       : zoominit,
                mapTypeId  : google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
                styles     : [{
                    featureType: 'administrative',
                    elementType: 'labels.text.fill',
                    stylers    : [{
                        color: '#444444'
                    }]
                },
                {
                    featureType: 'landscape',
                    elementType: 'all',
                    stylers    : [{
                        color: '#f2f2f2'
                    }]
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers    : [{
                        visibility: 'off'
                    }]
                },
                {
                    featureType: 'poi.business',
                    elementType: 'geometry.fill',
                    stylers    : [{
                        visibility: 'on'
                    }]
                },
                {
                    featureType: 'road',
                    elementType: 'all',
                    stylers    : [{
                        saturation: -100
                    }, {
                        lightness: 45
                    }]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'all',
                    stylers    : [{
                        visibility: 'simplified'
                    }]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.icon',
                    stylers    : [{
                        visibility: 'off'
                    }]
                },
                {
                    featureType: 'transit',
                    elementType: 'all',
                    stylers    : [{
                        visibility: 'off'
                    }]
                },
                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers    : [{
                        color: '#b4d4e1'
                    },
                    {
                        visibility: 'on'
                    }]
                }]
            };

            this.state.map = GM.init(myOptions, {
            });

            this.last = {
                lat: this.state.getMapCenter().lat,
                lng: this.state.getMapCenter().lng
            };

            this.initialLocation = GM.getLocationFromLatLng(this.last.lat, this.last.lng);

            document.getElementById('map_canvas_preview').style.display = 'none';

            GM.setCenter(this.initialLocation);

            this.state.map.setZoom(5);
        }
    }
};
</script>

<style scoped>
#g-map  {
  width: 80%;
  margin: 0 auto 15px;
  background: #ccc;
  transition: width 500ms ease-in-out;
  height: 100vw;
  order: 1;
}
@media (min-width: 1024px) {
  #g-map  {
    order: 2;
    width: 75%;
    height: 609px;
    position: absolute;
    left: 25%;
    margin: 0;
  }
}

#map_cover {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 2;
  display: none;
}

.map_canvas_preview {
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  z-index: 2;
  position: relative;
}
@media (min-width: 1024px)  {
  .map_canvas_preview {
    height: 100%;
  }
}

.map_canvas {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
}
@media (min-width: 1024px)  {
  .map_canvas {
    height: 609px;
  }
}

.mapContent {
  padding-top: 20px;
}
</style>
